"use client";

import { sha256 } from "js-sha256";
import Cookies from "js-cookie";

import { FacebookPropertyType } from "~/services/api/services/types/EventsEnum";
import { COOKIES } from "~/types/Cookie";
import { META_PIXELS } from "~/constants/metaPixels";

export function sendFacebookEvent(sendFacebookEvent, args, pixels: string[] = [META_PIXELS.DEFAULT]) {
    pixels.forEach(pixel => {
        sendFacebookEvent({
            type: FacebookPropertyType.FACEBOOK_EVENT,
            properties: {
                event_name: args.event_name,
                pixel_id: pixel,
                event_id: args.event_id,
                user_data: {
                    em: args.email && sha256(args.email),
                    ph: args.phone && sha256(args.phone),
                    fn: args.first_name && sha256(args.first_name),
                    ln: args.last_name && sha256(args.last_name),
                    ge: sha256("f"),
                    country: sha256("us"),
                    ct: args.city && sha256(args.city),
                    st: args.state && sha256(args.state),
                    zp: args.zip_code && sha256(args.zip_code),
                    external_id: args.external_id && sha256(args.external_id),
                    fbp: Cookies.get("_fbp"),
                    fbc: Cookies.get("_fbc"),
                    client_ip_address: Cookies.get(COOKIES.IP_ADDRESS),
                    client_user_agent: navigator.userAgent
                },
                custom_data: args.custom_data
            },
        });
    });

    return null;
}